export const ExternalLinks = {
  ServiceDesk: 'https://support.over-c.com/customer-support',
  HubspotSsoApi: 'https://hubspot-sso.over-c.net/hubspot/tickets',
  TermsAndConditions: 'https://over-c.com/end-user-licence-agreement-eula/',
  PrivacyPolicy: 'https://over-c.com/legal/privacy-policy/',
};
